import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import LOOKUP from 'constants/lookup';

const Body = ({ aggregateSales, branchOptions, beginDate, endDate }) => {
    let chartData;
    if (aggregateSales.length > 0) {
        chartData = aggregateSales.map((item) => {
            let returnObj = { ...item.branchSales };
            returnObj.date = item.date;
            return returnObj;
        });
    }
    return (
        <div id="taxSummaryReport">
            {
                aggregateSales.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    aggregateSales.length > 0 &&
                    //If there's DATA
                    <div className="clearFix">
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>
                        <div className="col-lg-12 mt-2">
                            <div className="col-lg-12">
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart width={730} height={250} data={chartData}>
                                        <XAxis dataKey="date" />

                                        <YAxis label={{ value: 'Sales (Dollars)', angle: -90, position: 'insideLeft' }} />
                                        <Tooltip />
                                        <Legend />

                                        {branchOptions.map((item, index) => { return (<Bar dataKey={item.text} fill={LOOKUP.BranchChartColors[index].colorCode} />) })}
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                        <div className="row m-0">
                            <div className="col-lg-4">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th className='tableHeaderColorGray'>Date</th>
                                            {branchOptions.map((item, index) => { return (<th key={index}>{item.text}</th>) })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            aggregateSales.map((item, index) => {
                                                return (
                                                    <tr key={index}>

                                                        <td>{item.date}</td>
                                                        {branchOptions.map((branch) => { return (<td>{item.branchSales[branch.text] ? getDollarFormat(item.branchSales[branch.text]) : 0}</td>) })}
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
};

export default Body;